module.exports = __webpack_public_path__ + "img/05-3-5灵活管理.2da262b4.svg";